import { render, staticRenderFns } from "./CardTaskPickup.vue?vue&type=template&id=0f12af3a&scoped=true"
import script from "./CardTaskPickup.vue?vue&type=script&lang=js"
export * from "./CardTaskPickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12af3a",
  null
  
)

export default component.exports